// src/scripts/islands/lift-me-up-main.ts
function setupGsap() {
  gsap.registerPlugin(ScrollTrigger);
  console.log("[LMU] Setup GSAP");
  const section = document.querySelector(`.lift-me-up-main`);
  if (!section) {
    console.log("[LMU] No section found");
    return;
  }
  const matchMedia = gsap.matchMedia();
  const titleContainer = section.querySelector(".lift-me-up-title");
  const extraTextTitle1 = section.querySelector(".lift-me-up-main__extra-text__title--1");
  const productForm = section.querySelector(".lift-me-up-main__product-form");
  matchMedia.add(
    { isMobile: "(max-width: 1023px)", isDesktop: "(min-width: 1024px)" },
    ({ conditions: { isMobile, isDesktop } }) => {
      const titleClips = titleContainer?.querySelectorAll(".lift-me-up-title__clip-path");
      if (titleClips?.length) {
        titleClips.forEach((clip) => {
          gsap.fromTo(
            clip,
            { clipPath: "inset(100% 0 0 0)" },
            {
              clipPath: "inset(0% 0 0 0)",
              ease: "none",
              scrollTrigger: {
                trigger: section,
                start: () => isMobile ? `top bottom+=${getNavHeight()}` : "top 80%",
                end: () => `top top+=${getNavHeight()}`,
                scrub: true
              }
            }
          );
        });
      }
      const bottleVideo = section.querySelector(".lift-me-up-bottle video");
      const bottle = section.querySelector(".lift-me-up-bottle");
      const bottleWrapper = section.querySelector(".lift-me-up-bottle-wrapper");
      if (bottleVideo && bottle && bottleWrapper) {
        if (isMobile) {
          console.log("[LMU] Scaling for mobile");
          gsap.fromTo(
            bottle,
            { scale: 1 },
            {
              scale: parseFloat(getComputedStyle(bottleWrapper).getPropertyValue("--final-scale")) || 0.3,
              ease: "none",
              scrollTrigger: {
                trigger: titleContainer,
                start: "top top+=100%",
                end: `top top+=${getNavHeight()}`,
                scrub: true
              }
            }
          );
          gsap.fromTo(
            bottle,
            { yPercent: 0 },
            {
              yPercent: -15,
              ease: "none",
              scrollTrigger: {
                trigger: titleContainer,
                start: `top top+=${getNavHeight()}`,
                end: `center top+=${getNavHeight()}`,
                scrub: true
              }
            }
          );
        } else {
          gsap.fromTo(
            bottle,
            { scale: 1 },
            {
              scale: parseFloat(getComputedStyle(bottleWrapper).getPropertyValue("--final-scale")) || 0.3,
              ease: "none",
              scrollTrigger: {
                trigger: section,
                start: "top top+=100%",
                end: "30% center",
                scrub: true
              }
            }
          );
        }
        bottleVideo.addEventListener("loadedmetadata", () => {
          const duration = bottleVideo.duration;
          bottleVideo.muted = true;
          bottleVideo.currentTime = 0;
          bottleVideo.pause();
          if (isMobile) {
            ScrollTrigger.create({
              trigger: section,
              start: () => isMobile ? `center center+=${getNavHeight()}` : `bottom bottom+=${getNavHeight()}`,
              end: () => isMobile ? `center center-=${getNavHeight()}` : "bottom bottom",
              scrub: 1.5,
              onUpdate: (self) => {
                bottleVideo.currentTime = duration * self.progress;
              }
            });
          } else {
            ScrollTrigger.create({
              trigger: section,
              start: () => isMobile ? `center center+=${getNavHeight()}` : `bottom bottom+=${getNavHeight()}`,
              end: () => isMobile ? `center center-=${getNavHeight()}` : "bottom bottom",
              scrub: 1.5,
              onUpdate: (self) => {
                bottleVideo.currentTime = duration * self.progress;
              }
            });
          }
        });
      } else {
        console.log("[LMU] No bottle");
      }
      if (extraTextTitle1) {
        gsap.fromTo(
          extraTextTitle1,
          { y: "100vh" },
          {
            y: extraTextTitle1.style.getPropertyValue("--translate-final") || "0vh",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: "top bottom",
              end: `top top+=${getNavHeight()}`,
              scrub: true
            }
          }
        );
        gsap.fromTo(
          extraTextTitle1,
          { y: extraTextTitle1.style.getPropertyValue("--translate-final") || "0vh" },
          {
            y: "-20vh",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: `top top+=${getNavHeight() - 50}`,
              end: `top top+=${getNavHeight() - 200}`,
              scrub: true
            }
          }
        );
      }
      const mainText = section.querySelector(".lift-me-up-main__text");
      if (mainText) {
        gsap.fromTo(
          mainText,
          { y: "50vh" },
          {
            y: mainText.style.getPropertyValue("--translate-final") || "0vh",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: "top bottom",
              end: `top top+=${getNavHeight()}`,
              scrub: true
            }
          }
        );
        gsap.fromTo(
          mainText,
          { y: mainText.style.getPropertyValue("--translate-final") || "0vh" },
          {
            y: "-20vh",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: `top top+=${getNavHeight() - 50}`,
              end: `top top+=${getNavHeight() - 200}`,
              scrub: true
            }
          }
        );
      }
      if (productForm) {
        const entryOffset = productForm.style.getPropertyValue("--entry-offset") || "-60vh";
        gsap.fromTo(
          productForm,
          { y: entryOffset },
          {
            y: "0",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: "top bottom",
              end: `top center-=${getNavHeight()}`,
              scrub: 0.5
            }
          }
        );
      }
      const extraText = section.querySelector(".lift-me-up-main__extra-text");
      if (extraText) {
        gsap.fromTo(
          extraText,
          { y: "50vh" },
          {
            y: "0vh",
            ease: "none",
            scrollTrigger: {
              trigger: section,
              start: `bottom bottom+=${getNavHeight()}`,
              end: "bottom bottom",
              scrub: true
            }
          }
        );
      }
      gsap.fromTo(
        section,
        { y: 0 },
        {
          y: "-50vh",
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "bottom bottom",
            end: `bottom top+=${getNavHeight()}`,
            scrub: true
          }
        }
      );
    }
  );
}
function setBottleContainerHeight() {
  const section = document.querySelector(".shopify-section-lift-me-up-main");
  const prevSection = section?.previousElementSibling;
  if (!section || !prevSection) {
    console.log("No section/prev section");
    return;
  }
  section.style.setProperty("--prev-section-height", `${prevSection.offsetHeight}px`);
}
function initBottleVideo(section) {
  const videoEl = section.querySelector(".lift-me-up-bottle-wrapper video");
  if (!videoEl) {
    return;
  }
  videoEl.pause();
  videoEl.currentTime = 0;
  videoEl.autoplay = false;
}
function setupLiftMeUpBottle() {
  const liftMeUpBottleWrapper = document.querySelector("div.lift-me-up-bottle-wrapper");
  if (!liftMeUpBottleWrapper) return;
  const liftMeUpBottle = liftMeUpBottleWrapper.querySelector("div.lift-me-up-bottle");
  if (!liftMeUpBottle) return;
  const liftMeUpBottleVideo = liftMeUpBottle.querySelector("video");
  if (!liftMeUpBottleVideo) return;
  const section = liftMeUpBottleWrapper.closest(".lift-me-up-main");
  if (!section) return;
  initBottleVideo(section);
  setBottleContainerHeight();
  setupGsap();
  window.addEventListener("resize", setBottleContainerHeight);
  let liftMeUpBottleWrapperOffsetTop = liftMeUpBottleWrapper.offsetTop;
  let liftMeUpBottleOffsetTop = liftMeUpBottle.offsetTop;
  liftMeUpBottleWrapper.style.setProperty("--bottle-height", `${liftMeUpBottle.getBoundingClientRect().height}px`);
  const liftMeUpResizeObserver = new ResizeObserver(() => {
    liftMeUpBottleWrapperOffsetTop = liftMeUpBottleWrapper.offsetTop;
    liftMeUpBottleOffsetTop = liftMeUpBottle.offsetTop;
    section.style.setProperty("--bottle-height", `${liftMeUpBottleVideo.getBoundingClientRect().height}px`);
  });
  liftMeUpResizeObserver.observe(document.body);
  liftMeUpResizeObserver.observe(section);
}
function getNavHeight() {
  const headerHeight = parseInt(
    getComputedStyle(document.body).getPropertyValue("--header-height").trim() || window.innerWidth < 764 ? "60" : "83"
  );
  const announcementHeight = parseInt(
    getComputedStyle(document.body).getPropertyValue("--announcement-bar-height").trim() || "0"
  );
  return headerHeight + announcementHeight;
}
setupLiftMeUpBottle();
